import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { VehicleProvider } from './contexts/VehicleContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Portal from './components/Portal';
import './App.css';

// Protected Route Component
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

// Role-based redirect component
const RoleBasedRedirect: React.FC = () => {
  const { currentUser } = useAuth();
  
  if (currentUser?.role === 'warehouse' || currentUser?.role === 'admin') {
    return <Navigate to="/portal" />;
  } else {
    return <Navigate to="/dashboard" />;
  }
};

// Main App Component
const AppContent: React.FC = () => {
  const { isAuthenticated, currentUser } = useAuth();

  return (
    <Router>
      <Routes>
        <Route 
          path="/login" 
          element={!isAuthenticated ? <Login /> : <RoleBasedRedirect />} 
        />
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/portal" 
          element={
            <ProtectedRoute>
              <Portal />
            </ProtectedRoute>
          } 
        />
        {/* Zoho routes removed */}
        <Route path="/" element={<RoleBasedRedirect />} />
      </Routes>
    </Router>
  );
};

function App() {
  return (
    <AuthProvider>
      <VehicleProvider>
        <AppContent />
      </VehicleProvider>
    </AuthProvider>
  );
}

export default App;
